import { instances } from '../core'

function requestSuccess (config) {
  // TODO: add logic
  return config
}

function requestError (error) {
  // TODO: add logic
  return Promise.reject(error)
}

function responseSuccess (response) {
  // TODO: add logic
  if (response.isAxiosError) {
    return Promise.reject(response)
  }

  return response
}

function responseError (error) {
  // TODO: add logic
  return Promise.reject(error)
}

Object.values(instances)
  .forEach(i => {
    i.interceptors.request.use(
      requestSuccess,
      requestError,
      { synchronous: true }
    )

    i.interceptors.response.use(
      responseSuccess,
      responseError,
      { synchronous: true }
    )
  })
